import { NgModule } from '@angular/core';
import { Route, ROUTES } from '@angular/router';
import { ConfirmModalComponent } from 'app/messaging/messaging-chat/confirm-modal/confirm-modal.component';
import { AwardModalComponent } from 'app/projects/award-modal/award-modal.component';
import { CreateMilestoneModalComponent } from 'app/projects/create-milestone-modal/create-milestone-modal.component';
import { CreateMilestoneUpgradeModalComponent } from 'app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.component';
import { DeleteModalComponent } from 'app/projects/delete-modal/delete-modal.component';
import { HiremeModalComponent } from 'app/projects/hireme-modal/hireme-modal.component';
import { MilestoneConfirmModalComponent } from 'app/projects/milestone-confirm-modal/milestone-confirm-modal.component';
import { RequestMilestoneModalComponent } from 'app/projects/request-milestone-modal/request-milestone-modal.component';
import { ConfirmCloseCourseModalComponent } from './academy/instructor/dashboard-page/confirm-close-course-modal/confirm-close-course-modal.component';
import { ConfirmDeleteCourseModalComponent } from './academy/instructor/dashboard-page/confirm-delete-course-modal/confirm-delete-course-modal.component';
import { ConfirmPublishCourseModalComponent } from './academy/instructor/dashboard-page/confirm-publish-course-modal/confirm-publish-course-modal.component';
import { ConfirmUnpublishCourseModalComponent } from './academy/instructor/dashboard-page/confirm-unpublish-course-modal/confirm-unpublish-course-modal.component';
import { PaymentsModalComponent } from './financial-operations/payments-deposit/payments-modal/payments-modal.component';
import { CallAlertModalComponent } from './messaging/messaging-chat/call-alert-modal/call-alert-modal.component';
import { GroupchatManagementModalComponent } from './messaging/messaging-chat/groupchat-management-modal/groupchat-management-modal.component';
import { MilestoneCancelModalComponent } from './projects/milestone-cancel-modal/milestone-cancel-modal.component';
import { ExpandedBidOverlayComponent } from './projects/project-view/expanded-bid-overlay/expanded-bid-overlay.component';
import { ProjectViewOverlayModalComponent } from './projects/project-view/project-view-overlay-modal/project-view-overlay-modal.component';
import { GiveGetModalComponent } from './referrals/give-get-modal/give-get-modal.component';
import { TaskModalComponent } from './tasks/task-modal/task-modal.component';
import { TutorialModalComponent } from './tutorial/home/tutorial-modal/tutorial-modal.component';

// Add here your modals configurations
// NOTE: make sure to also add it in `tsconfig.compat.json`!
const appModals: ReadonlyArray<Route & { compat?: true }> = [
  {
    component: ConfirmModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/confirm-modal/confirm-modal.module#ConfirmModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: HiremeModalComponent,
    loadChildren:
      'app/projects/hireme-modal/hireme-modal.module#HiremeModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: RequestMilestoneModalComponent,
    loadChildren:
      'app/projects/request-milestone-modal/request-milestone-modal.module#RequestMilestoneModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: CreateMilestoneModalComponent,
    loadChildren:
      'app/projects/create-milestone-modal/create-milestone-modal.module#CreateMilestoneModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: CreateMilestoneUpgradeModalComponent,
    loadChildren:
      'app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.module#CreateMilestoneUpgradeModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: AwardModalComponent,
    loadChildren:
      'app/projects/award-modal/award-modal.module#AwardModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CallAlertModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/call-alert-modal/call-alert-modal.module#CallAlertModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: GroupchatManagementModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/groupchat-management-modal/groupchat-management-modal.module#GroupchatManagementModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: PaymentsModalComponent,
    loadChildren:
      'app/financial-operations/payments-deposit/payments-modal/payments-modal.module#PaymentsModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: DeleteModalComponent,
    loadChildren:
      'app/projects/delete-modal/delete-modal.module#DeleteModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectViewOverlayModalComponent,
    loadChildren:
      'app/projects/project-view/project-view-overlay-modal/project-view-overlay-modal.module#ProjectViewOverlayModule',
    path: 'hack_path_not_used',
  },
  {
    component: TaskModalComponent,
    loadChildren: 'app/tasks/tasks.module#TasksModule',
    path: 'hack_path_not_used',
  },
  {
    component: TutorialModalComponent,
    loadChildren:
      'app/tutorial/home/tutorial-modal/tutorial-modal.module#TutorialModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneConfirmModalComponent,
    loadChildren:
      'app/projects/milestone-confirm-modal/milestone-confirm-modal.module#MilestoneConfirmModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ConfirmPublishCourseModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/confirm-publish-course-modal/confirm-publish-course-modal.module#ConfirmPublishCourseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ConfirmUnpublishCourseModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/confirm-unpublish-course-modal/confirm-unpublish-course-modal.module#ConfirmUnpublishCourseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ConfirmCloseCourseModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/confirm-close-course-modal/confirm-close-course-modal.module#ConfirmCloseCourseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ConfirmDeleteCourseModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/confirm-delete-course-modal/confirm-delete-course-modal.module#ConfirmDeleteCourseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneCancelModalComponent,
    loadChildren:
      'app/projects/milestone-cancel-modal/milestone-cancel-modal.module#MilestoneCancelModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ExpandedBidOverlayComponent,
    loadChildren:
      'app/projects/project-view/expanded-bid-overlay/expanded-bid-overlay.module#ExpandedBidOverlayModule',
    path: 'hack_path_not_used',
  },
  {
    component: GiveGetModalComponent,
    loadChildren:
      'app/referrals/give-get-modal/give-get-modal.module#GiveGetModalModule',
    path: 'hack_path_not_used',
  },
];

@NgModule({
  providers: [
    // Modals have nothing to do with routes, but this is a hack to make the
    // CLI code splitting and ngc lazy module analysis and compilation work,
    // pending proper fix in https://github.com/angular/angular-cli/issues/4541
    { provide: ROUTES, useValue: appModals, multi: true },
  ],
})
export class AppModalsModule {}
